// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  DownIcon,
  InternalIcon,
  Link,
  Stack,
  Typography,
  useTheme
} from "@carrotfertility/carotene-core"
import React from "react"
import { Paths } from "#/utils/Paths"
import { formatPastAppointmentDate, formatProviderName } from "./formatting"
import { AppointmentsAvatar } from "./AppointmentsAvatar"
import type { PastAppointment } from "./types"

// Placeholder data for scaffolding only. Will be replaced with data from the API.
const pastAppointments: PastAppointment[] = [
  {
    date: "2026-06-12",
    type: "Initial consult",
    provider: { name: "Marcus Reed", title: "MD", photoUrl: null }
  },
  {
    date: "2026-05-05",
    type: "Initial consult",
    provider: { name: "Bob Smith", title: "MD", photoUrl: null }
  }
]

function Appointment({ appointment }: { appointment: PastAppointment }): JSX.Element {
  const theme = useTheme()
  return (
    <Stack
      key={appointment.date}
      spacing={theme.spacing(theme.tokens.spacing.md)}
      sx={{ flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start" }}
    >
      <AppointmentsAvatar name={appointment.provider.name} photoUrl={appointment.provider.photoUrl} />
      <Stack sx={{ flexDirection: "column", alignItems: "flex-start" }}>
        <Typography variant="h6">{formatProviderName(appointment.provider)}</Typography>
        <Typography>{appointment.type}</Typography>
        <Typography>{formatPastAppointmentDate(appointment.date)}</Typography>
        <Link
          marginBlockStart={theme.spacing(theme.tokens.spacing.md)}
          endIcon={<InternalIcon fontSize="small" color="primary" />}
          href={Paths.TELEMEDICINE_BOOKING}
        >
          Book again
        </Link>
      </Stack>
    </Stack>
  )
}

export function PastAppointments(): JSX.Element {
  const theme = useTheme()
  return (
    <Accordion size="medium" defaultExpanded sx={{ "&:before": { display: "none" } }}>
      <AccordionSummary
        expandIcon={<DownIcon fontSize="large" />}
        aria-controls="past-appointments-content"
        id="past-appointments-header"
      >
        <Typography variant="h4" component="h3">
          Past appointments
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack
          spacing={theme.spacing(theme.tokens.spacing.xxxl)}
          sx={{ flexDirection: "row", justifyContent: "flex-start" }}
        >
          {pastAppointments.map((appointment) => (
            <Appointment key={appointment.date} appointment={appointment} />
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  )
}
